// Resolve the canonical short user ID from an oauth2-proxy /oauth2/userinfo payload.
//
// Microsoft Entra (DEV): preferred_username / email are real emails (e.g. "abbiswa@tbdir.net")
//   → we take the local part ("abbiswa").
// CIAM B2C (UAT/Prod): email/preferred_username are GUIDs, and `user` is the bare short ID
//   → we fall back to `user`, but never to a GUID or opaque object id.
//
// This keeps the stored identity equal to what the backend derives from the JWT
// (jwt_utils strips the @domain on the Microsoft issuer), so history/logs stay keyed
// on the same short ID in every environment.

const GUID_RE = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

const localPartIfEmail = (v) =>
  typeof v === 'string' && v.includes('@') && v.split('@')[1].includes('.')
    ? v.split('@')[0]
    : null;

export function resolveShortId(data) {
  if (!data) return null;
  // 1) Real email claims win (Microsoft).
  const fromEmail = localPartIfEmail(data.preferredUsername) || localPartIfEmail(data.email);
  if (fromEmail) return fromEmail;
  // 2) Fall back to `user` (CIAM bare short ID), unless it's a GUID.
  const user = data.user;
  if (typeof user === 'string' && user && !GUID_RE.test(user)) {
    return user.split('@')[0];
  }
  return null;
}
